import { render, staticRenderFns } from "./article.vue?vue&type=template&id=57348506&scoped=true"
import script from "./article.js?vue&type=script&lang=js&external"
export * from "./article.js?vue&type=script&lang=js&external"
import style0 from "./article.vue?vue&type=style&index=0&id=57348506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57348506",
  null
  
)

export default component.exports